import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import WebRouter from './WebRouter.js'
import Firebase, {FirebaseContext} from './Services/firebase'

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <FirebaseContext.Provider value={ new Firebase()}>
      <WebRouter />
    </FirebaseContext.Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
